export default "__VITE_ASSET__C97DowC0__"